import React, { Component, Fragment } from 'react';
import NewPasswordAndCode from './resetPasswordComponents/NewPasswordAndCode';
import EmailForm from './resetPasswordComponents/EmailForm';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

class ResetPasswordForm extends Component {

  state = {
    showEmailForm: true,
    email: '',
    showCommunicate: false
  }

  changeEmail = (e) => {
    this.setState({ email: e.target.value });
  }

  resetEmail = () => {
    this.setState({ email: '' });
  }

  changeShowCommunicate = (value) => {
    this.setState({ showCommunicate: value });
  }

  toggleView = () => {
    this.setState({ showEmailForm: !this.state.showEmailForm })
  }

  render() {
    if (this.state.showEmailForm) {
      var content = (
        <EmailForm
          changeEmail={this.changeEmail}
          changeShowCommunicate={this.changeShowCommunicate}
          email={this.state.email}
          showCommunicate={this.state.showCommunicate}
          toggleView={this.toggleView}
          locale={this.props.locale}
        />
      );
    } else {
      var content = (
        <NewPasswordAndCode
          resetEmail={this.resetEmail}
          changeShowCommunicate={this.changeShowCommunicate}
          email={this.state.email}
          toggleView={this.toggleView}
          locale={this.props.locale}
        />
      );
    }
    var title = TransHelper.translate(this.props.locale, 'content.common.backToLogin');

    return (
      <div className="layout layout--bg">
        <div className="wrapper">
          <div className="steps-header mb-70">
            <AppLink to="routes.url.login" title={title} className="button button--text">
              <FontAwesomeIcon
                icon={['fas', 'angle-left']}
                size="lg"
              />
            </AppLink>
          </div>
          {content}
        </div>
      </div>
    );
  }
}

export default ResetPasswordForm;
